import React from 'react';
import { translated } from '../../utils/TranslationUtil';

export const RingIconOld: React.FC<{}> = () => (
    <svg
        width='100%'
        height='100%'
        viewBox='0 0 100 64'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <title>{translated('Accessibility.SvgTitle.ringIcon')}</title>
        <g id='ring-logo'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M94.9814 25.2281V37.3178C94.9814 42.0401 91.086 45.8812 86.2981 45.8812C81.5105 45.8812 77.6156 42.0401 77.6156 37.3146V25.2281C77.6156 20.5066 81.5105 16.6649 86.2981 16.6649C91.086 16.6649 94.9814 20.5066 94.9814 25.2281ZM99.792 50.6699V25.2245V25.2135C99.7833 17.886 93.7341 11.9238 86.2939 11.9216C78.8595 11.9238 72.8084 17.8909 72.8048 25.2281V37.3178C72.8048 44.6563 78.858 50.6258 86.2981 50.6258C89.5008 50.6258 92.5521 49.5234 94.9814 47.5048L94.9818 50.6992C94.9781 55.3376 90.8986 59.256 86.0739 59.256C83.4104 59.256 80.757 58.0609 79.1483 56.139C79.1441 56.133 79.1388 56.1272 79.1343 56.1227C78.6752 55.5767 78.0019 55.2646 77.2835 55.2646C75.9571 55.2646 74.8778 56.3287 74.8778 57.6372C74.8778 58.1789 75.0688 58.7091 75.4158 59.1308C75.4205 59.1366 75.4244 59.1418 75.4295 59.148C77.9671 62.1858 81.9465 64.0001 86.0739 64.0001C93.6381 64.0001 99.7928 58.03 99.7928 50.6924C99.7928 50.6846 99.792 50.6777 99.792 50.6699Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M53.0347 11.9216C45.599 11.9216 39.5467 17.9007 39.5409 25.2526C39.5405 25.2562 39.5405 25.2598 39.5405 25.2636V47.1909C39.5405 48.5017 40.6197 49.5687 41.9461 49.5687C43.2726 49.5687 44.3514 48.5017 44.3514 47.1909V25.2636C44.3514 20.5295 48.2466 16.6777 53.0347 16.6777C57.8229 16.6777 61.718 20.5295 61.718 25.2636V47.1909C61.718 48.5017 62.7968 49.5687 64.1233 49.5687C65.4497 49.5687 66.5285 48.5017 66.5285 47.1909V25.2636V25.2582C66.5259 17.9043 60.4722 11.9216 53.0347 11.9216Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M28.8709 13.804C27.4864 13.804 26.3604 14.8749 26.3604 16.1912V47.1822C26.3604 48.4981 27.4864 49.5687 28.8709 49.5687C30.2553 49.5687 31.3814 48.4981 31.3814 47.1822V16.1912C31.3814 14.8749 30.2553 13.804 28.8709 13.804Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.7257 14.3737C19.7178 14.3675 19.7102 14.3615 19.7015 14.3553C19.7007 14.3545 19.6586 14.3267 19.6579 14.3259C17.4109 12.7542 14.7693 11.923 12.0516 11.923H12.0485C12.0369 11.9216 12.0186 11.9216 12.0062 11.9216H12.006C5.05267 11.9236 0.00336641 17.5317 0.00121143 25.2286C0.000403282 25.2392 0 25.2519 0 25.2629V47.1906C0 48.5013 1.06756 49.5687 2.37959 49.5687C3.69242 49.5687 4.75972 48.5013 4.75972 47.1898V25.2629C4.75972 20.0475 7.60614 16.6775 12.0105 16.6775C13.8022 16.6775 15.5194 17.2226 16.9757 18.2549C16.9851 18.2623 16.9941 18.2679 17.004 18.2733C17.3981 18.5386 17.8564 18.6787 18.3312 18.6787C19.6439 18.6787 20.7117 17.6114 20.7117 16.2998C20.7117 15.5386 20.3439 14.8208 19.7257 14.3737Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M28.8713 0C26.7946 0 25.1051 1.68907 25.1051 3.76606C25.1051 5.84074 26.7946 7.52941 28.8713 7.52941C30.9473 7.52941 32.6366 5.84074 32.6366 3.76606C32.6366 1.68907 30.9473 0 28.8713 0Z'
                fill='#FFA80A'
            />

        </g>
    </svg>
);